<template>
  <button @click="showMore" class="mt-6 btn-primary" :class="[isMobile ? 'w-full' : 'btn-icon-plus btn-small', showAll ? 'hidden' : ''].join(' ')">{{ seeMoreText }}</button>
  <div id="show-more-accordions" :class="showAll ? '' : 'hidden'">
    <slot />
  </div>
  <a :href="showAllUrl" class="mt-6 btn-primary" :class="[isMobile ? 'w-full' : 'btn-icon-arrow btn-small', showAll ? '' : 'hidden'].join(' ')">{{ isMobile ? seeAllTextMobile : seeAllText }}</a>
</template>

<script>
export default {
  name: 'ellevio-web-show-more-accordions',
  data() {
    return {
      isMobile: true,
      showAll: false
    }
  },
  props: {
    seeMoreText: {
      type: String,
      default: 'Se fler frågor'
    },
    seeAllText: {
      type: String,
      default: 'Se alla våra frågor och svar'
    },
    seeAllTextMobile: {
      type: String,
      default: 'Se alla'
    },
    showAllUrl: {
      type: String,
      default: '#'
    }
  },
  computed: {
    matchMediaQuery() {
      return window.matchMedia(' (min-width: 768px) ')
    }
  },
  methods: {
    showMore() {
      this.showAll = !this.showAll
    },
    resize() {
      this.isMobile = this.matchMediaQuery ? !this.matchMediaQuery.matches : true
    }
  },
  mounted() {
    this.isMobile = this.matchMediaQuery ? !this.matchMediaQuery.matches : true
    this._boundedResize = this.resize.bind(this)
    window.addEventListener('resize', this._boundedResize)
  },
  unmounted() {
    window.removeEventListener('resize', this._boundedResize)
  }
}
</script>
